import React from 'react';
import Navbar from './Navbar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="bg-[#F5F3F0] w-full h-screen text-theme-dark border-t border-gray-200 flex flex-col h-full pl-4 pr-4">
      <Header />
      <div className="flex-1 overflow-y-auto rounded-t-sm mt-8">
        {children}
      </div>
      <Navbar />
    </div>
  );
};

export default Layout;
